module.exports = __webpack_public_path__ + "static/img/card_4_2.d0a09d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_4_2.png
// module id = 1XCF
// module chunks = 0